/*
 * Copyright (c) 2021, salesforce.com, inc.
 * All rights reserved.
 * SPDX-License-Identifier: BSD-3-Clause
 * For full license text, see the LICENSE file in the repo root or https://opensource.org/licenses/BSD-3-Clause
 */
import React from 'react'
import PropTypes from 'prop-types'
import {Box, Text} from '@salesforce/retail-react-app/app/components/shared/ui'

const AddressDisplay = ({
    address,
    showAddressDetailsInline,
    isBillingAddress = false,
    hideFields,
    ...props
}) => {
    return (
        <Box {...props}>
            {!hideFields?.name && (
                <Text>
                    {address.firstName} {address.lastName}
                </Text>
            )}
            {showAddressDetailsInline ? (
                <>
                    <Text>
                        {address.address1}, {address.city}, {address.stateCode} {address.postalCode}
                        , {address.countryCode}
                    </Text>
                    {!hideFields?.phone && <Text>{address.phone}</Text>}
                </>
            ) : (
                <>
                    {isBillingAddress ? (
                        <>
                            <Text>
                                {address.apartment && `${address.apartment}, `}
                                {address.address1}
                            </Text>
                            <Text>
                                {address.city}, {address.postalCode}
                            </Text>
                        </>
                    ) : (
                        <Text>
                            {address.apartment && `${address.apartment}, `}
                            {address.address1}, {address.city}, {address.postalCode}
                        </Text>
                    )}
                    {/* <Text>{address.countryCode}</Text> */}
                </>
            )}
        </Box>
    )
}

AddressDisplay.propTypes = {
    address: PropTypes.object,
    showAddressDetailsInline: PropTypes.bool,
    isBillingAddress: PropTypes.bool,
    hideFields: PropTypes.object
}

export default AddressDisplay
